import { createModel } from '@preact/signals-react';
import type { Model, ModelConstructor } from '@preact/signals-react';
import type { Logger } from '@thinkalpha/ui-ioc/core/types/Logger';
import { AGGREGATED_RISK_WIDGET_CONFIG_BY_KIND, columnTemplateStateSchema } from 'src/features/aggregated-risk/config';
import { AggregatedRiskSelfOwnedModel } from 'src/models/AggregatedRiskWidgetModel/AggregatedRiskSelfOwnedModel';
import type { AggregatedRiskSelfOwnedModelShape } from 'src/models/AggregatedRiskWidgetModel/AggregatedRiskSelfOwnedModel';
import { stickyFilterStateSchema } from 'src/models/StickyFilterModel';
import type { TableModel } from 'src/models/TableModel';
import type { WidgetHostContainer } from 'src/services/WorkspaceService/Container/Container';
import type { WidgetId } from 'src/services/WorkspaceService/selfOwnedWidget';
import type { ReactBindings } from 'src/types/bindings';
import type { z } from 'zod';

export const tradersWidgetStateSchema = stickyFilterStateSchema.extend({
    columnTemplate: columnTemplateStateSchema,
});

export type TradersWidgetState = z.infer<typeof tradersWidgetStateSchema>;

interface TradersSelfOwnedModelInit {
    container: WidgetHostContainer;
    tabId: WidgetId;
    persisted: TradersWidgetState;
    logger: Logger;
    queryClient: ReactBindings['QueryClient'];
    slugMapServiceProvider: ReactBindings['SlugMapServiceProvider'];
    table: TableModel;
}

export const TradersSelfOwnedModel: ModelConstructor<AggregatedRiskSelfOwnedModelShape, [TradersSelfOwnedModelInit]> =
    createModel<AggregatedRiskSelfOwnedModelShape, [TradersSelfOwnedModelInit]>((init: TradersSelfOwnedModelInit) => {
        return new AggregatedRiskSelfOwnedModel({
            ...init,
            config: AGGREGATED_RISK_WIDGET_CONFIG_BY_KIND.traders,
        });
    });

export type TradersSelfOwnedModel = Model<AggregatedRiskSelfOwnedModelShape>;
